import { BaseComponentTheme, BaseTheme } from './themes/base-theme';
/**
 * Base theme
 *
 * @private Not intended as public API and subject to change
 */
export const ChartBaseTheme = BaseTheme;
/**
 * Base component theme
 *
 * @private Not intended as public API and subject to change
 */
export const ChartBaseComponentTheme = BaseComponentTheme;
//# sourceMappingURL=ChartThemeTypes.js.map